import React, { useState } from "react";
import { Button, Modal } from "react-bootstrap";
import i18n from "i18next";
import cropxLogo from "../../img/logo/CropX_logo.svg";

export const MaintananceModal = () => {
  const [show, setShow] = useState(true);

  const handleClose = () => setShow(false);
  return (
    <Modal
      show={show}
      onHide={handleClose}
      aria-labelledby="contained-modal-title"
      className="mod_bb_mainanance"
      animation={false}
      backdrop="static"
      backdropClassName="bb-modal-backdrop"
    >
      <Modal.Header closeButton>
        <Modal.Title>Gepland onderhoud in uitvoering</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="float-right">
          <img alt="CropX" className="d-none d-sm-block" width="200" src={cropxLogo} />
          <img alt="CropX" className="d-inline-block d-sm-none" width="150" src={cropxLogo} />
        </div>
        <p>
          We werken momenteel alle perceelsinformatie bij voor het seizoen 2026 om je de meest
          nauwkeurige ervaring te bieden.
        </p>
        <p>
          Deze onderhoudswerkzaamheden zullen niet langer dan één dag duren. We zijn zo snel
          mogelijk weer online.
        </p>
        <p>Bedankt voor je geduld en onze excuses voor het ongemak.</p>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={handleClose}>{i18n.t("Close")}</Button>
      </Modal.Footer>
    </Modal>
  );
};
